import React from 'react';
import { Divider, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormInstance } from 'antd/lib/form';
import UserForm from '@pages/Access/Users/UserViewerModal/UserForm';

const { Paragraph } = Typography;

interface ICustomerAdminFormProps {
  form: FormInstance;
}

const CustomerAdminForm: React.FC<ICustomerAdminFormProps> = ({ form }) => {
  const { t } = useTranslation('customers');

  return (
    <>
      <Paragraph style={{ padding: '10px 0' }}>
        {t('form.help.admin')}
      </Paragraph>
      <Divider />
      <UserForm form={form} isNewUser />
    </>
  );
};

export default CustomerAdminForm;
